import React, { Component } from "react";
import ViewSDKClient from "./ViewSDKClient";
import './PdfViewer.css';

//https://github.com/adobe/pdf-embed-api-samples/blob/master/More%20Samples/React%20Samples

class PdfViewer extends Component {
    componentDidMount() {
        const viewSDKClient = new ViewSDKClient();
        viewSDKClient.ready().then(() => {
            /* Invoke file preview */
            viewSDKClient.previewFile("pdf-div", {
                /* Pass the embed mode option here */
                embedMode: "SIZED_CONTAINER"
            }, this.props.url, this.props.filename, this.props.fileid);
        });
    }

    render() {
        return <div id="pdf-div" className="sized-container-div" style={{ width: '100%' , height: this.props.height ? this.props.height : 500 }}/>;
    }
}

export default PdfViewer;